import { render, staticRenderFns } from "./SyncTicketList.vue?vue&type=template&id=1ef05fc6&"
import script from "./SyncTicketList.vue?vue&type=script&lang=ts&"
export * from "./SyncTicketList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports